import React from 'react';
import Reflux from 'reflux';
import { OrderedMap } from 'immutable';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import classNames from 'classnames';
import TeleprompterHeaderClocks from 'main/components/show/cuesheet.prompter/teleprompterHeaderClocks.jsx';
import FullScreenCuesheetStore from 'flux/stores/cuesheet.fullscreen/FullScreenCuesheetStore';
import RouteActions from 'flux/actions/RouteActions';
import FullScreenCuesheetActions from 'flux/actions/cuesheet.fullscreen/FullScreenCuesheetActions';
import { DisplayTypes } from 'shared/constants/FlowConstants';
import ShowsMenu from 'shared/components/menus/shows.jsx';
import EventShowListStore from 'flux/stores/EventShowListStore';
import ModalActions from 'flux/actions/ModalActions';
import UIRegions from 'shared/constants/UIRegions';
import EventViewStore from 'flux/stores/EventViewStore';
import ViewMenu from 'main/components/show/cuesheet/viewMenu.jsx';
import UserSessionStore from 'flux/stores/UserSessionStore';
import TeamViewStore from 'flux/stores/TeamViewStore';

export default React.createClass({
  displayName: 'TeleprompterHeader',

  mixins: [
    Reflux.connectFilter(EventShowListStore, 'shows', (state) =>
      state.get('shows'),
    ),
    Reflux.connect(FullScreenCuesheetStore, 'fullScreenCuesheet'),
    Reflux.connect(EventViewStore, 'event'),
    Reflux.connect(UserSessionStore, 'user'),
    Reflux.connect(TeamViewStore, 'team'),
  ],

  _onBackButtonClick() {
    const { teamId, eventId } = this.props;
    RouteActions.goToEvent({ teamId, eventId });
  },

  _openRemoteTeleprompterModal() {
    ModalActions.show(UIRegions.RemoteTeleprompterModal);
  },

  _getShowSelector() {
    const { showId } = this.props;
    const { shows } = this.state;

    if (!shows) return null;

    let showsMap = OrderedMap({});

    shows.forEach((show) => {
      const displayType = show.get('displayType');
      if (
        displayType === DisplayTypes.list ||
        displayType === DisplayTypes.schedule
      )
        return;
      showsMap = showsMap.set(show.get('_id'), show);
    });

    return (
      <ShowsMenu
        shows={showsMap}
        activeId={showId}
        onChange={this._handleShowSelection}
      />
    );
  },

  _handleShowSelection(show) {
    const { teamId, eventId } = this.props;
    RouteActions.goToTeleprompterInitialization({
      teamId,
      eventId,
      showId: show.get('_id'),
    });
  },

  _getPrompterPresentationView() {
    return (
      <button
        className="remote-prompter-btn"
        onClick={this._openRemoteTeleprompterModal}
      >
        <Icon name="television" className="header-icon" />
        &nbsp; Remote Prompter
      </button>
    );
  },

  _setFeaturedCell() {
    const { rowId, columnId } = this.props;
    FullScreenCuesheetActions.setFullScreenFeaturedCell(rowId, columnId);
  },

  render() {
    const { event, fullScreenCuesheet, shows, user, team } = this.state;
    const { loading } = fullScreenCuesheet;
    const { eventId, teamId, showId } = this.props;

    if (!shows || !event || !team || loading) {
      return <div className="prompter-header-loading-animation" />;
    }

    return (
      <header className={classNames('prompter-header')}>
        <div className="prompter-header-left">
          <button className="back-btn" onClick={this._onBackButtonClick}>
            <Icon name="arrow-left" />
            Back
          </button>
          <div className="event-details">
            <span className="event-title">{event.get('title')}</span>
            <div className="prompter-header-show-selector">
              {this._getShowSelector()}
            </div>
          </div>
        </div>
        <div className="prompter-header-right" style={{ width: '470px' }}>
          <TeleprompterHeaderClocks />
          {this._getPrompterPresentationView()}
          <Icon
            name="arrows-alt"
            onClick={FullScreenCuesheetActions.toggleFullScreen}
            className="header-icon"
          />
          <ViewMenu
            displayContent={
              <span className="featured-utility-panel-view-menu">
                <Icon name="eye" className="header-icon" />
              </span>
            }
            {...{
              onRoutedisplayThemeSwitch: false,
              teamId,
              eventId,
              showId,
              user,
              team,
              event,
              onRoute: (params) => this._setFeaturedCell(params),
            }}
          />
        </div>
      </header>
    );
  },
});
